import type { CSSProperties } from "react";

export const COPILOT_LOGO_SRC = "/assets/copilot-logo.png";

interface CopilotLogoProps {
  size?: number;
  className?: string;
  active?: boolean;
  label?: string;
  style?: CSSProperties;
}

/** The product mark is fixed; unlike deployment branding it is never tenant-customized. */
export function CopilotLogo({
  size = 24,
  className,
  active = false,
  label,
  style,
}: CopilotLogoProps): JSX.Element {
  const classes = ["copilot-logo", active ? "is-active" : "", className ?? ""]
    .filter(Boolean)
    .join(" ");

  return (
    <img
      className={classes}
      src={COPILOT_LOGO_SRC}
      alt={label ?? ""}
      aria-hidden={label ? undefined : true}
      style={{ width: size, height: size, ...style }}
    />
  );
}
